import React from "react";
import { useDelete } from "../../../../../api/useCall";
import t from "../../../../../i18n";
import { useNavigate } from "react-router";
import ModalForm from "@ui/Modal/Form";
import Text from "@ui/Text";
import { toPath } from "../../../../../router/helpers/path";
import useToasts from "@ui/Toast/useToasts";
import { useDisplayFilterPreferences } from "../../../EvolutionSubHeader/useDisplayFilterPreferences";

interface P {
  onRequestClose: () => void;
  projectId: string;
}

const DeleteDisplayFiltersModalForm = ({ onRequestClose, projectId }: P) => {
  const { addToast } = useToasts();
  const navigate = useNavigate();
  const deleteFilters = useDelete("/projects/:projectId(uuid)/displayFilters");
  const { setDisplayFilterPreferences } = useDisplayFilterPreferences(projectId);

  const handleSubmit = React.useCallback(async () => {
    try {
      await deleteFilters({
        routeParams: { projectId },
      });
      setDisplayFilterPreferences([]);
      void navigate(toPath("/projects/:projectId/settings", { projectId }));
    } catch {
      addToast("error", t("errors.backend_error"));
      return false;
    }
    return true;
  }, [deleteFilters, projectId, navigate, addToast, setDisplayFilterPreferences]);

  return (
    <ModalForm
      onRequestClose={onRequestClose}
      onSubmit={handleSubmit}
      okButtonName={t("project.settings.analyses.delete_filters.modal.submit_button.label")}
      okButtonVariant="destructive"
    >
      <Text>{t("project.settings.analyses.delete_display_filters.modal.description")}</Text>
    </ModalForm>
  );
};

export default React.memo(DeleteDisplayFiltersModalForm);
